import { createFileRoute, notFound } from "@tanstack/react-router";
import { PortalNotFound } from "@/components/PortalNotFound";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/employee/$")({
  head: () => pageHead('Employee Page Not Found', 'This AKIVA employee portal page does not exist.', '/employee', true),
  beforeLoad: () => { throw notFound(); },
  notFoundComponent: PortalNotFound,
});
